module.exports = "<div class=\"_landing\">\n\n  <v-container fluid>\n\n    <v-layout class=\"login-card-container\" column justify-space-around>\n      <v-layout row justify-space-around>\n\n        <cm-login-card></cm-login-card>\n\n      </v-layout>\n    </v-layout>\n\n  </v-container>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/landing/landing.vue
// module id = 369
// module chunks = 0